module.exports = __webpack_public_path__ + "media/svg-new/ic-trophy-7522c2bf.svg";